
module.exports = {
  // TODO: change your profile information here
  name: "Vishal Garg",
  greeting: "Hey 👋",
  greetingDescription: "I'm Vishal Garg and I'm a Sr Software Engineer!",
  githubUrl: "https://github.com/vishalgrg",
  linkedinUrl: "https://www.linkedin.com/in/vishal75/",
  cvLink: "https://drive.google.com/drive/folders/1TkK_Bj0RYbf0ozEA4ghI7pBrAdf3G-Nu?usp=sharing",
};
